import React from 'react';
import { useDict } from '../../contexts/LanguageContext';
import Modal from './Modal';

const TimeOutModal = ({ isOpen }) => {
    const dict = useDict();

    const handleClose = () => {
        window.location.reload();
    };
    return (
        <Modal
            toggle={handleClose}
            isOpen={isOpen}
            onCancel={handleClose}
            cancelText={dict.close}
            headerType="invest-withdrawal"
            title={dict.sessionTimeoutTitle}
        >
            <div>
                <span className="font-size-12">
                    {dict.sessionTimeoutText}
                </span>
            </div>
        </Modal>
    );
};

export default TimeOutModal;
